const { default: Thunk } = require('redux-thunk');
const { routerMiddleware: RouterMiddleware } = require('connected-react-router');
const History = require('./history');
const AppContext = require('../app-context');
const { makeErrorHandler } = require('../utils/redux-helpers');
const { gaMiddleware } = require('../utils/analytics');

const handlers = AppContext.context.handlers.errorHandling;

// eslint-disable-next-line hapi/hapi-scope-start, hapi/no-arrowception
const consoleLogger = (store) => (next) => (action) => {

    const state = store.getState();

    console.group(`[redux] ${action.type}`);
    console.info('[redux] dispatching', action.type, action.payload?.result?.result || action.payload?.result || action.payload);

    if (action?.type?.includes('SET_HISTORY_PATHNAME')) {
        console.log('[redux] signup context', state.signup.context);
        console.log('[redux] auth state', state.auth);
        console.trace();
    }

    console.groupEnd();

    return next(action);
};

module.exports = [
    makeErrorHandler({ onError: handlers.pushNotification }),
    Thunk,
    RouterMiddleware(History),
    gaMiddleware
    // consoleLogger
];
